import { render, staticRenderFns } from "./TrademarkPriorityForm.vue?vue&type=template&id=66c3b524&"
import script from "./TrademarkPriorityForm.vue?vue&type=script&lang=js&"
export * from "./TrademarkPriorityForm.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkPriorityForm.vue?vue&type=style&index=0&id=66c3b524&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports